import { CHAT, type ChatLine } from '@somnhold/protocol';
import type { ChatChannel } from './chat.ts';

/** The same line said in both channels: who said it and what, stamped within a moment of each other. */
const SAME_LINE_MS = 5000;

/**
 * A live room's chat and the keep's as one, so the group's talk follows you from the bastion into the
 * waiting room and the fight. A line goes to both: the keep's reaches whoever is in the bastion or in
 * another room, the room's shows at once over the speaker's head. A line that comes back from both shows once.
 */
export class GroupChannel implements ChatChannel {
  chat: ChatLine[] = [];
  onChat: (line: ChatLine) => void = () => undefined;

  constructor(
    private room: ChatChannel,
    private keep: ChatChannel,
  ) {
    for (const line of [...keep.chat, ...room.chat].sort((a, b) => a.at - b.at)) if (!this.said(line)) this.chat.push(line);
    this.chat = this.chat.slice(-CHAT.keep);
    room.onChat = (line) => this.take(line);
    keep.onChat = (line) => this.take(line);
  }

  say(text: string): void {
    this.keep.say(text);
    this.room.say(text);
  }

  private said(line: ChatLine): boolean {
    return this.chat.some((c) => c.pid === line.pid && c.text === line.text && Math.abs(c.at - line.at) < SAME_LINE_MS);
  }

  private take(line: ChatLine): void {
    if (this.said(line)) return;
    this.chat = [...this.chat, line].slice(-CHAT.keep);
    this.onChat(line);
  }
}
